import { CameraModel } from 'src/app/engine/models/camera.model';
import { CameraMotionModel } from '../../models/camera-motion.model';

export class EngineCameraStateModel {
  storedCameras: { [key: string]: CameraModel };
  cameraMotion: CameraMotionModel;
  panMode: string;
  zoomed: boolean;
  lockCamera: boolean;
  cameraFlyTo: CameraModel;
  chapterCameraEnabled: boolean;
}
